import React, { useCallback } from "react";
import HeroButton from "/app/src/components/HeroUi/Button";
import { useTranslation } from "react-i18next";

export default function RefreshSetting({
  refresh,
  newSetting,
  setNewSetting,
}: {
  refresh: () => void;
  newSetting: boolean;
  setNewSetting: (newSetting: boolean) => void;
}) {
  const { t } = useTranslation();

  const newSettingSetter = useCallback(() => {
    refresh();
    setNewSetting(!newSetting);
  }, [refresh, newSetting, setNewSetting]);

  return (
    <HeroButton color="primary" onClick={newSettingSetter} size="sm">
      {t("translation:refresh_list")}
    </HeroButton>
  );
}
